var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectGoals = function SvgSelectGoals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#select_goals_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.679 34.576c-5.841 8.999-9.234 19.734-9.234 31.262 0 31.752 25.74 57.492 57.492 57.492s57.492-25.74 57.492-57.492S99.689 8.346 67.937 8.346c-10.771 0-20.85 2.962-29.468 8.116l-21.806-5.204 3.016 23.318Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#select_goals_svg__b)",
    d: "M59.36 74.898v13.57c0 2.498 2.043 4.524 4.565 4.524h20.688l9.416 7.636v-7.636h4.137c2.521 0 4.566-2.026 4.566-4.525V61.034c0-2.499-2.045-4.525-4.566-4.525H76.772L59.36 74.899Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#select_goals_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M54.501 30.336c-12.183 0-22.06 9.876-22.06 22.06 0 4.847 1.566 9.328 4.216 12.969l-2.72 5.974 6.73-1.76v-.002a21.965 21.965 0 0 0 13.834 4.878c12.184 0 22.06-9.876 22.06-22.06 0-12.183-9.877-22.06-22.06-22.06Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m81.103 66.895 1.514-.002 6 15.897-3.278 1.237-1.425-3.774h-2.811l-.003-.003v.004h-2.8l-1.44 3.777-3.273-1.247 6.05-15.887 1.463-.002v.005l.003-.005Zm-.003 5.998v.006l-1.467 3.852H82.592l-1.471-3.9-.018.047-.003-.005ZM63.585 46.465v3.471H60.47c-.24 2.602-1.287 4.972-3.029 6.86 1.505.596 3.23.914 5.077.914v3.471c-3.016 0-5.816-.699-8.114-1.997v-.003.003c-2.298 1.299-5.098 1.997-8.113 1.997h-1.287v-3.47h1.287c1.846 0 3.572-.318 5.076-.915-1.741-1.887-2.79-4.258-3.029-6.86h-3.115v-3.47h7.446v-3.564h1.735v.005-.005h1.736v3.563h7.445Zm-9.181 8.463v-.003a8.016 8.016 0 0 0 2.575-4.989h-2.575v-.004.005H51.83a8.017 8.017 0 0 0 2.574 4.988v.003Z",
    clipRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#select_goals_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BADBFF",
    d: "M122.043 15.685H98.969a2.871 2.871 0 0 0-2.895 2.895v20.435c0 .766.937 1.107 1.448.596l5.279-5.28c.425-.425 1.106-.68 1.788-.68h17.539c1.618 0 2.98-1.363 2.98-2.98V18.58c-.085-1.618-1.447-2.896-3.065-2.896Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M119.231 20.964h-16.432c-.596 0-1.022.511-1.022 1.022 0 .596.511 1.022 1.022 1.022h16.432c.596 0 1.022-.511 1.022-1.022.085-.51-.426-1.022-1.022-1.022ZM112.845 27.095h-10.046c-.596 0-1.022.51-1.022 1.022 0 .596.511 1.021 1.022 1.021h10.046c.596 0 1.022-.51 1.022-1.021 0-.596-.511-1.022-1.022-1.022Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#select_goals_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#select_goals_svg__f)",
    d: "M22.485 119.273c8 0 14.486-6.485 14.486-14.485 0-8-6.486-14.486-14.486-14.486S8 96.788 8 104.788s6.485 14.485 14.485 14.485Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.266 103.352a6.186 6.186 0 0 1-1.206 3.669l4.082 4.082-1.355 1.356-4.082-4.082a6.188 6.188 0 0 1-3.67 1.206 6.238 6.238 0 0 1-6.23-6.231 6.238 6.238 0 0 1 6.23-6.23 6.238 6.238 0 0 1 6.231 6.23Zm-10.54 0a4.318 4.318 0 0 0 4.313 4.314 4.318 4.318 0 0 0 4.314-4.314 4.319 4.319 0 0 0-4.314-4.313 4.319 4.319 0 0 0-4.313 4.313Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "select_goals_svg__a",
    width: 134.984,
    height: 134.984,
    x: 0.445,
    y: 0.346,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "select_goals_svg__c",
    width: 52.119,
    height: 52.119,
    x: 30.442,
    y: 28.336,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "select_goals_svg__d",
    width: 37.034,
    height: 32.168,
    x: 94.074,
    y: 13.685,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "select_goals_svg__e",
    width: 36.971,
    height: 36.971,
    x: 6,
    y: 88.302,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "select_goals_svg__b",
    x1: 81.046,
    x2: 81.046,
    y1: 56.509,
    y2: 100.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "select_goals_svg__f",
    x1: 22.485,
    x2: 22.485,
    y1: 90.302,
    y2: 119.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })))));
};
export default SvgSelectGoals;